import $ from 'jquery';

var host;
var hash;
var prodId;
export default class Production {
  constructor(app) {
    this.app = app;
    host = this.app.host;
    this.getData();

  }
  getData(){
    $('#prodModal').on('hidden.bs.modal', function (e) {
      console.log('hh'+window.location.href);
      var newAddr = window.location.href.replace('id='+prodId, '');
      window.location.replace(newAddr);
    })
    var productionCat_arr;
    var productionCat_xhr = new XMLHttpRequest();
    productionCat_xhr.open('get', this.app.host + '/api/categorys', true);
    productionCat_xhr.send();
    productionCat_xhr.onload = function() {
      if (productionCat_xhr.status == 200) {
        productionCat_arr = JSON.parse(productionCat_xhr.responseText);
        // console.log(productionCat_arr);
        for(var i=0;i<productionCat_arr.data.length;i++){
          //
          // if(productionCat_arr.data[i].id==1){
          //
          // }else{

            $('.hashSlider').append(''+
            '<a class="hashlink__item__box" href="#sub'+productionCat_arr.data[i].id+'" >'+
              '<div class="hashlink__item">'+
                '<img src="'+host+productionCat_arr.data[i].img_path+'" />'+
              '<h5 class="hashlink__item__title">'+productionCat_arr.data[i].name+'</h5>'+
              '</div>'+
            '</a>'
            )
            $('.sub__box').append(''+
              '<div class="page-content sub'+productionCat_arr.data[i].id+'">'+
                '<div class="submenu">'+
                '</div>'+
                '<div class="prod">'+
                '</div>'+
              '</div>'
            )
            this.getSubCate(productionCat_arr.data[i].id)
          // }

        }
        this.setSlider();
        this.hashchange();
      }
    }.bind(this)
  }
  getSubCate(id){
    // console.log(host);
    var cate_arr;
    var cate_xhr = new XMLHttpRequest();
    cate_xhr.open('get', this.app.host + '/api/productsByCategory/'+id, true);
    cate_xhr.send();
    cate_xhr.onload = function() {
      if (cate_xhr.status == 200) {
        cate_arr = JSON.parse(cate_xhr.responseText);
        // console.log(cate_arr);
        var k =0;
        for(var x in cate_arr.data){
          // console.log(x);
          k++;
          $('.sub'+id+' .submenu').append(''+
              '<a class="index__button" href="#sub'+id+'?sm='+k+'">'+x+'</a>'
          )
          for(var i=0;i<cate_arr.data[x].length;i++){
            $('.sub'+id+' .prod').append(''+
            '<a class="prod__item" href="#sub'+id+'?sm='+k+'&id='+cate_arr.data[x][i].id+'">'+
              '<div class="prod__img">'+
                '<img src="'+host+cate_arr.data[x][i].medias[0].path+'" />'+
              '</div>'+
              '<h4 class="prod__title">'+cate_arr.data[x][i].title+'</h4>'+
            '</a>'
            )
          }
        }
        this.app.updatePage();
        this.hashchange();
      }
    }.bind(this)
  }
  getProd(){
    var prod_arr;
    var prod_xhr = new XMLHttpRequest();
    prod_xhr.open('get', this.app.host + '/api/products', true);
    prod_xhr.send();
    prod_xhr.onload = function() {
      if (prod_xhr.status == 200) {
        prod_arr = JSON.parse(prod_xhr.responseText);
        // console.log(prod_arr);
        for(var x in prod_arr.data){
          // console.log(x);
        }
        this.setSlider();
        this.app.updatePage();
      }
    }.bind(this)
  }
  setSubSlider(){
    if($('.submenu').children().length>1){
      $('.submenu').slick({
        infinite: true,
        slidesToShow: 4,
        rows: 2,
        slidesToScroll: 1,
        touchMove: false,
        mobileFirst: false,
        autoplay: false,
        responsive: [{
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 567,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
        ]
      })
    }
  }
  setSlider(){
    $('.hashSlider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      touchMove: false,
      mobileFirst: false,
      autoplay: false,
      arrows:true,
      responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
      ]
    })
  }
  refreshSlder(){
    // if($('.submenu').children().length>8){
    //   $(".submenu").slick('setPosition');
    // }
    if($(".slick-slider").length>1){
      $(".slick-slider").slick('setPosition');
    }


  }
  getDetail(pid){
    var hostAddr = this.app.host;
    var prod_arr;
    var detail_xhr = new XMLHttpRequest();
    detail_xhr.open('get', this.app.host + '/api/products/'+pid, true);
    detail_xhr.send();
    detail_xhr.onload = function() {
      if (detail_xhr.status == 200) {
        prod_arr = JSON.parse(detail_xhr.responseText);
        $('#prodModal .modal-title').html(prod_arr.data[0].title);
        var imgPath = " ";
        for (var j = 0; j < prod_arr.data[0].medias.length; j++) {
          imgPath += '<img src="' + hostAddr + prod_arr.data[0].medias[j].path + '"/>'
        }
        // console.log(imgPath);
        $('#prodModal .img__slider').html('' + imgPath);
        // $('#prodModal .img__slider').slick('setPosition');
        $('#prodModal .content').html(prod_arr.data[0].content_desc);
        $('#prodModal').modal('show')

      }
    }.bind(this)
  }
  hashchange() {
    //
    hash = this.app.hash;
    // console.log(hash);
    this.hashId = hash.replace("sub","");
    var sm = this.app.sm;
    prodId = this.app.prodId;

    console.log("sm:"+sm,"prodId"+prodId)
    $('.prod__item').each(function(){
      if(sm!==""){
        $(this).hide();
        if($(this).attr('href').split('sm=')[1].split('&')[0] == sm){
          $(this).show();
        }
      }
    })
    $('.index__button').each(function(){
      if($(this).attr('href').split("?sm=")[1] == sm){
        $(this).addClass("is-active");
      }else{
        $(this).removeClass("is-active");
      }
    })
    $(".hashlink__item__box").each(function(){
      if($(this).attr('href') == ("#"+hash)){
        $(this).children(".hashlink__item").addClass('is-active');
      }
      else{
        $(this).children(".hashlink__item").removeClass('is-active');
      }
    })
    if(prodId==""){
      // $('.detail').hide();
      // $('.prod').show();
      if(hash == ""){
        window.location+= $(".hashlink__item__box").first().attr('href');
      }
    }else{
      this.getDetail(prodId);
    }
    // this.getProd();
    this.refreshSlder();
  }
}
